import React from "react"
import "./OfficeMap.scss"
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet"
import L from "leaflet"
import iconRetinaUrl from "leaflet/dist/images/marker-icon-2x.png"
import iconUrl from "leaflet/dist/images/marker-icon.png"
import shadowUrl from "leaflet/dist/images/marker-shadow.png"

import { useTranslation } from "react-i18next"

if (typeof window !== "undefined") {
  delete L.Icon.Default.prototype._getIconUrl

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: iconRetinaUrl,
    iconUrl: iconUrl,
    shadowUrl: shadowUrl,
  })
}

function OfficeMap({ officeCoordinates }) {
  const { t } = useTranslation()

  const position = officeCoordinates

  if (typeof window === "undefined") {
    return null
  }

  return (
    <section className="office-map">
      <h3>{t("officeMap.title")}</h3>
      <MapContainer
        center={position}
        zoom={14}
        noMoveStart={true}
        boxZoom={false}
        doubleClickZoom={false}
        dragging={false}
        keyboard={false}
        scrollWheelZoom={false}
        tap={false}
        touchZoom={false}
      >
        <TileLayer
          minZoom={14}
          maxZoom={18}
          attribution='&amp;copy <a href="https://allsports.by">AllSportS</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker
          title={t("officeMap.marker.title")}
          alt={t("officeMap.marker.alt")}
          attribution={t("officeMap.marker.attribution")}
          position={position}
          style={{ fontWeight: "bold" }}
        >
          <Popup autoPan={false}>
            {t("officeMap.popup.item-1")}
            <br />
            {t("officeMap.popup.item-2")} <br />
            {t("officeMap.popup.item-3")}
            <br />
          </Popup>
        </Marker>
      </MapContainer>
    </section>
  )
}

export default OfficeMap
